(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('CampaignRespondentListController', Controller);

    Controller.$inject = ['$scope', '$state', '$interval', 'oddCampaignRespondentService', 'campaign', 'campaignRespondents'];

    function Controller($scope, $state, $interval, oddCampaignRespondentService, campaign, campaignRespondents ) {
        $scope.campaign = campaign;
        $scope.campaignRespondents = campaignRespondents;

        // If users are being created, re-fetch them
        if (_.findIndex($scope.campaignRespondents, {RespondentStatus: 'Creating'}) > -1) {
            var intervalPromise = $interval(function () {
                oddCampaignRespondentService
                    .getCampaignRespondents($scope.campaign.ODDBusinessUnitID, $scope.campaign.ODDCampaignID)
                    .then(function (updatedRespondents) {
                        var updatedRespondent;
                        _.each($scope.campaignRespondents, function (campaignRespondent, index) {
                            if (campaignRespondent.RespondentStatus === 'Creating') {
                                updatedRespondent = _.find(updatedRespondents, {ODDCampaignRespondentID: campaignRespondent.ODDCampaignRespondentID});
                                if (updatedRespondent && updatedRespondent.RespondentStatus !== 'Creating') {
                                    $scope.campaignRespondents[index] = updatedRespondent;
                                }
                            }
                        });
                        // No more respondents in creation
                        if (_.findIndex(updatedRespondents, {RespondentStatus: 'Creating'}) === -1) {
                            $interval.cancel(intervalPromise);
                        }
                    });
            }, 2000);

            $scope.$on('$destroy', function() {
                if (intervalPromise) {
                    $interval.cancel(intervalPromise);
                }
            });
        }

        $scope.goToCampaign = function () {
            $state.go('odd.surveyCampaignEdit', { ODDCampaignID: campaign.ODDCampaignID }, {reload:true});
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', { ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID }, { reload: true });
        };

    }
})();